import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.partner_services';
export const Component = loadable(
  () => import('./containers/PartnerServicesContainer')
);
export { default as propsFormatter } from './propsFormatter';
